import { Date } from 'components/date';

import style from './activity-header.module.scss';

interface ActivityHeaderProps {
  Icon: React.ComponentType<{ className?: string }>;
  createdBy: string;
  createdAt: string;
  dateFormat?: string;
}

export const ActivityHeader = ({
  Icon,
  createdBy,
  createdAt,
  dateFormat = 'lll',
}: ActivityHeaderProps) => {
  return (
    <div className={style.header}>
      <Icon className={style.icon} />
      <div className={style.info}>
        <h6>{createdBy}</h6>
        <Date
          className={style.date}
          date={createdAt}
          format={dateFormat}
          showTime
        />
      </div>
    </div>
  );
};
